import { Link } from "react-router-dom";
import styles from "../../constants/styles";

const BackToHomeButton = () => {
  return (
    <Link to="/" className={`${styles.button} ${styles.hoverShrinkEffect}`}>
      Return to previous page
    </Link>
  );
};

export default BackToHomeButton;
